/* rl-live-poll — when an upcoming Refind Live drop is about to go live, polls the
   Section Rendering API and swaps the live (Firework) hero into the DOM in place,
   so a waiting visitor doesn't have to refresh.

   Mounts only on the upcoming-state hero ([data-rl-poll]); the live/empty states
   don't render that element, so this is a no-op there. The backend flips the drop
   to "live" within ~10 min before its scheduled time (see drop-system-schema.md),
   so polling runs across a bounded window around scheduled_at, not indefinitely.

   The live hero embeds <fw-herounit>; the Firework SDK is already loaded on this
   page by the archive section. ensureFirework() is a defensive fallback. */

(function () {
  var POLL_MS = 60 * 1000;               // cadence (flip is cron-quantized; sub-minute buys nothing)
  var START_BEFORE_MS = 12 * 60 * 1000;  // begin polling 12 min before scheduled_at
  var STOP_AFTER_MS = 12 * 60 * 1000;    // give up 12 min after (covers a delayed cron run)

  function ensureFirework() {
    if (window._fwn || window.__fwnLoaded) return;
    window.__fwnLoaded = true;
    var s = document.createElement('script');
    s.async = true;
    s.src = '//asset.fwcdn3.com/js/fwn.js';
    document.head.appendChild(s);
  }

  function stop(root) {
    var state = root.__rlPoll;
    if (state) {
      state.done = true;
      clearInterval(state.interval);
      clearTimeout(state.startTimeout);
      clearTimeout(state.stopTimeout);
    }
    if (root.__rlPollVis) {
      document.removeEventListener('visibilitychange', root.__rlPollVis);
      root.__rlPollVis = null;
    }
    root.__rlPoll = null;
  }

  function swap(root, liveNode) {
    var state = root.__rlPoll;
    if (!state || state.done) return; // a concurrent poll already claimed the swap
    state.done = true;
    var imported = document.importNode(liveNode, true);
    ensureFirework();
    stop(root);            // clear timers/listeners before the node leaves the DOM
    root.replaceWith(imported);  // connecting <fw-herounit> upgrades it via the loaded SDK
    document.dispatchEvent(new CustomEvent('rl:live-swapped'));  // let rl-fw-fallback watch the swapped-in hero
  }

  function mount(root) {
    stop(root); // clear any prior timers (e.g. theme-editor section reloads)

    var raw = root.getAttribute('data-rl-target');
    var sectionId = root.getAttribute('data-rl-section-id');
    var target = raw ? new Date(raw).getTime() : NaN;
    if (isNaN(target) || !sectionId) return;

    var state = { interval: null, startTimeout: null, stopTimeout: null, polling: false, done: false };
    root.__rlPoll = state;

    function poll() {
      if (state.done || document.hidden) return;
      var url = location.pathname + '?section_id=' + encodeURIComponent(sectionId) + '&_=' + Date.now();
      fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html || state.done) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var live = doc.querySelector('.rl-hero--live');
          if (live) swap(root, live);
        })
        .catch(function () { /* transient network error — next tick retries */ });
    }

    function startPolling() {
      if (state.polling || state.done) return;
      state.polling = true;
      poll(); // immediate first check
      state.interval = setInterval(poll, POLL_MS);
      state.stopTimeout = setTimeout(function () { stop(root); },
        Math.max(0, (target + STOP_AFTER_MS) - Date.now()));
    }

    var msUntilStart = (target - START_BEFORE_MS) - Date.now();
    if (msUntilStart <= 0) {
      startPolling();
    } else {
      state.startTimeout = setTimeout(startPolling, msUntilStart);
    }

    root.__rlPollVis = function () {
      if (!document.hidden && state.polling && !state.done) poll();
    };
    document.addEventListener('visibilitychange', root.__rlPollVis);
  }

  function mountAll(scope) {
    (scope || document).querySelectorAll('[data-rl-poll]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mountAll(); });
  } else {
    mountAll();
  }

  // Theme-editor support: re-bind / clean up across section reloads.
  document.addEventListener('shopify:section:load', function (e) { mountAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-rl-poll]').forEach(stop);
  });
})();
